/**
 * Copyright (c) 2026, CheckPlus Limited
 */
const withoutTrailingSlash = (value) => {
  if (typeof value !== "string") return value;
  return value.replace(/\/+$/, "");
};

const withTrailingSlash = (value) => {
  const normalized = withoutTrailingSlash(value);
  return normalized ? normalized + "/" : normalized;
};

// Build configuration stores URLs without a trailing slash. API routes add
// their own leading slash, while existing photo callers append an object key
// directly and therefore receive exactly one trailing slash here.
exports.API_ENDPOINT = withoutTrailingSlash(
  process.env.REACT_APP_API_ENDPOINT
);
exports.DEFAULT_PAYMENT_MINIMUM = 100.0;
exports.DEFAULT_PAYMENT_MINIMUM_LIMIT = 10.0;

exports.MIN_RECURRING_OCCURRENCES = 1;
exports.MAX_RECURRING_OCCURRENCES = 36;

exports.PAYMENT_MINIMUM = 10.0;
exports.MIN_STATEMENT_DESCRIPTOR_LENGTH = 5;
exports.MAX_STATEMENT_DESCRIPTOR_LENGTH = 22;
exports.DEFAULT_LANGUAGE = "en";
exports.DEFAULT_LANGUAGE_ARRAY = ["zh", "en", "cn"];

exports.PHOTO_PATH = withTrailingSlash(process.env.REACT_APP_PHOTO_PATH);
exports.TIMESTAMP = 60 * 60 * 1000; //One Hour
exports.DONOR_AUTH = "donorAuth";
exports.ADMIN_AUTH = "adminAuth";
exports.ORG_AUTH = "orgAuth";
// Which kind of organisation the current org session belongs to — "business"
// or "nonprofit". ORG_AUTH says an organisation is signed in; this says which
// workspace it opens. Written alongside ORG_AUTH and cleared with it.
exports.ORG_KIND = "orgKind";

// Platform configuration
const appPlatform = process.env.REACT_APP_PLATFORM || "checkplus";
exports.PLATFORM = appPlatform;
exports.COMPANY_NAME = appPlatform === "plug" ? "Plug" : "CheckPlus";
exports.ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

exports.HOME_PAGE = process.env.REACT_APP_HOME_PAGE;
exports.MAIN_DOMAIN = process.env.REACT_APP_MAIN_DOMAIN;
exports.URL_BEGINNING = process.env.REACT_APP_URL_BEGINNING;
exports.HEADER_LIMIT = 6;

exports.STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;
// Marketplace donations always settle through CheckPlus's Stripe account
// (every destination is a nonprofit), regardless of which platform bundle
// built this page — see Checkout.js.
exports.STRIPE_KEY_CHECKPLUS = process.env.REACT_APP_STRIPE_KEY_CHECKPLUS;
exports.STRIPE_PRICING_TABLE_ID = process.env.REACT_APP_STRIPE_PRICING_TABLE_ID;
exports.STRIPE_PHOTO_PATH = "https://uploads.stripe.com/v1/files";

exports.ORG_PAYMENT_LIST_LIMIT = 20;
exports.ORG_PAYMENT_LIST_SORT = 'updatedAt';

exports.ENV = process.env.REACT_APP_ENV;
